import React from 'react'
import { Route, Routes } from 'react-router-dom'

import { nestedRoutePath, routes } from '../../../../constants/routes'

import CreatePayout from './create'
import ViewPayout from './view'
import ListPayouts from './list'

const PayoutsIndex = () => {
    return (
        <Routes>
            <Route path={nestedRoutePath(routes.adminFinancePayoutsIndex, routes.adminFinancePayoutsCreate)} element={<CreatePayout />} />
            <Route path={nestedRoutePath(routes.adminFinancePayoutsView, routes.adminFinancePayoutsView)} element={<ViewPayout />} />
            <Route index element={<ListPayouts />} />
        </Routes>
    )
}

export default PayoutsIndex
